import { Modal } from "antd";
import React from "react";
import db from "../../../constants/database";

type FaqProps = {
  visible: boolean;
  onHandleOk: () => void;
  onCancel: () => void;
};

const FaqModal: React.FC<FaqProps> = ({ visible, onCancel }) => {
  return (
    <div>
      <Modal
        title=""
        centered
        open={visible}
        onCancel={onCancel}
        bodyStyle={{ backgroundColor: "rgba(1, 9, 37, 0.83)" }}
        width={750}
        footer={null}
      >
        <div className="bg-[#fff] h-full font-abel px-2">
          <div className="w-full text-center">
            <img
              src={db.contingency}
              alt="25th and Staffing"
              className="w-full"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FaqModal;
